/**
 * Company: SPHMedia
 * Description: [MyBH menu]
 */

import RecommendedLogo from "@assets/images/recommended-logo.svg";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

type MyBHMenuProps = {
  activeTab: "untukmu" | "pilihanku";
  onTabChange: (tab: "untukmu" | "pilihanku") => void;
  isSticky?: boolean;
};

/**
 * MyBHMenu
 * Description: [MyBH menu items]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MyBHMenu({
  activeTab,
  onTabChange,
  isSticky = false,
}: MyBHMenuProps): ReactElement {
  const isActive =
    "text-sm font-[700] text-text-body relative after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[2px] after:bg-brand-primary hover:bg-transparent";
  const buttonStyle =
    "flex justify-center basis-1/2 md:max-w-[201px] h-[40px] gap-2 items-center font-primary leading-[150%] px-6 py-4 text-xs font-[500] text-neutral-700 hover:bg-[rgba(196,229,255,0.5)]";

  const getTabStyle = (tab: "untukmu" | "pilihanku") =>
    twMerge(buttonStyle, activeTab === tab && isActive);

  return (
    <div
      className={twMerge(
        "flex justify-center border-b-2 border-border-strong mt-2.5",
        isSticky && "bg-bh-bg-blue-tint",
      )}
    >
      <button
        className={getTabStyle("untukmu")}
        onClick={() => {
          onTabChange("untukmu");
        }}
      >
        <img src={RecommendedLogo} width={24} alt="title-logo" />
        Untukmu
      </button>
      <button
        className={getTabStyle("pilihanku")}
        onClick={() => {
          onTabChange("pilihanku");
        }}
      >
        Pilihanku
      </button>
    </div>
  );
}
